import React from 'react';
import { format } from 'date-fns';
import { sr } from 'date-fns/locale';
import { MessageSquare } from 'lucide-react';

const DiscussionTable = ({ topics, selectedId, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!topics?.length) {
    return (
      <div className="text-center py-16 text-gray-500">
        <p className="text-lg font-medium">Nema diskusija</p>
        <p className="text-sm mt-1">Pokušajte sa drugačijim filterima</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 bg-gray-50">
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Naslov / Sadržaj</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Autor</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Datum</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Status</th>
          </tr>
        </thead>
        <tbody>
          {topics?.map((topic) => (
            <tr
              key={topic?.id}
              onClick={() => onSelect(topic)}
              className={`border-b border-gray-100 cursor-pointer transition-colors ${
                selectedId === topic?.id ? 'bg-blue-50' : 'hover:bg-gray-50'
              }`}
            >
              <td className="py-3 px-4">
                <div className="flex items-start gap-2">
                  <MessageSquare className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-gray-900 truncate max-w-xs">{topic?.title}</p>
                    <p className="text-xs text-gray-500 mt-0.5 truncate max-w-xs">{topic?.body?.substring(0, 60)}{topic?.body?.length > 60 ? '...' : ''}</p>
                    {topic?.commentCount > 0 && (
                      <p className="text-xs text-blue-500 mt-0.5">{topic?.commentCount} komentar(a)</p>
                    )}
                  </div>
                </div>
              </td>
              <td className="py-3 px-4">
                <p className="font-medium text-gray-800">{topic?.authorName || 'N/A'}</p>
              </td>
              <td className="py-3 px-4 text-gray-600 whitespace-nowrap">
                {topic?.createdAt ? format(new Date(topic?.createdAt), 'dd.MM.yyyy', { locale: sr }) : '-'}
              </td>
              <td className="py-3 px-4">
                {!topic?.isActive || !topic?.isVisible
                  ? <span className="px-2 py-1 text-xs font-medium bg-red-100 text-red-700 rounded-full">Skriven</span>
                  : <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">Aktivan</span>
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DiscussionTable;
